<template>
  <div class="h-100">
    <div class="pb-2 pt-4">
      <div class="stepper-wrapper">
        <div class="stepper-item" v-for="(n) in parseInt(stepper.total)" :key="n" :class="{'active':(n == (stepper.completed+1)),'completed':(n <= (stepper.completed))}">
          <div class="step-counter">
            <span>{{n}}</span>
          </div>
        </div>
      </div>
    </div>
    <div id="wrapper" class="col-md-10 mr-auto ml-auto" style="height:calc(100vh - 47px);overflow:scroll;">
      <!-- Patient details-->
      <transition enter-active-class="slideInRight">
        <card>
          <div slot="header">
            <div class="row">
              <div class="col-8">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Patient Details") }}
                </h4>
              </div>
              <div class="col-4 text-right pt-2" v-if="PATIENT_SELECTED">
                <i class="fa fa-times-circle fa-2x text-muted" style="font-weight: 100" @click="resetPatientSelection()"></i>
              </div>
            </div>
          </div>

          <!-- Patient search -->
          <div class="row" v-if="!PATIENT_SELECTED">
            <div class="col-12">
              <cool-select class="custom-input" :placeholder="$t('message.Start typing Name / EMR ID / Mobile No')" :items="[]" ref="select" disable-filtering-by-search @search="searchPatients" item-text="firstName" item-value="name" :search-text.sync="patientSearchText">
                <template slot="no-data">
                  <div v-show="patientSearchText  && patientSearchText.length > 2  && patients.length<1">{{$t('message.No patients found')}}</div>
                </template>
              </cool-select>
              <div style="align-items: center" class="pl-3 pr-1">
                <div class="row" v-for="patient in patients" :key="patient._id" @click="selectPatient(patient)">
                  <div class="pr-1 col-11 autocomplete-result">
                    <div class="row">
                      <div class="col-2 pl-0 pr-0">
                        <profile-image :file-id="patient.profileImage" image-class="avatar border-gray text-center" :image-style="'background-size: cover; border-radius: 50%;width:50px;height: 50px;'" v-if="patient.profileImage">
                        </profile-image>
                        <i class="fa fa-user-injured text-center" v-if="!patient.profileImage" style="background: #888;padding: 10px;border-radius: 50%;color: #fff;border: 4px solid;width: 50px;height: 50px;font-size: large;"></i>
                      </div>
                      <div class="col-10">
                        <h6 class="item-name">
                          {{ patient.firstName }} {{ patient.lastName }}
                        </h6>
                        <div class="row">
                          <div class="col-3 pr-0">{{ patient.gender }}</div>
                          <div class="col-8 pr-0">{{ getAge(patient.dob) }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pl-0 col-1" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="PATIENT_SELECTED">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-user"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{ laborder.patient.firstName }}
                    {{ laborder.patient.lastName }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-info-circle"></i>
                  </span>
                </div>
                <div class="col-md-10 col-9 pl-0">
                  <span>{{laborder.patient.patientId}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-mobile"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{laborder.patient.mobileNumber}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-center">
                  <check-mark-svg v-if="PATIENT_SELECTED == true"></check-mark-svg>
                </div>
              </div>
            </div>
          </div>
        </card>
      </transition>

      <!-- Patient Prescriptions  -->
      <transition enter-active-class="slideInUp">
        <div v-if="prescriptions.length >0" class="mt-3">
          <div class="col-md-12">
            <h6>{{ $t("message.Prescriptions") }}</h6>
          </div>
          <card v-for="prescription in prescriptions" :key="prescription._id">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-user"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{ $t("message.Dr") }}.{{" "}}{{ prescription.appointmentId.provider.firstName }}
                    {{ prescription.appointmentId.provider.lastName }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-clock"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <span>{{getFormattedDatetime(prescription.created)}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-1 col-3 text-center">
                  <span>
                    <i class="fa fa-microscope"></i>
                  </span>
                </div>
                <div class="col-md-8 col-9 pl-0">
                  <div v-for="labtest in prescription.prescriptions.labPrescription" :key="labtest._id">
                    {{labtest.test}}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                  <n-button type="primary" size="sm" class="btn-padding light mr-2" round @click.native="selectPrescription(prescription)">
                    <i slot="label" class="now-ui-icons arrows-1_minimal-right"></i>
                    {{ $t("message.Create Lab Order") }}
                  </n-button>
                </div>
              </div>
            </div>
          </card>

          <div class="col-12">
            <n-pagination :page-count="prescriptionsPagination.totalPages" v-model="prescriptionsPagination.pageNumber"></n-pagination>
          </div>
          <div class="col-12 text-center">
            <span> {{ $t("message.OR") }} </span>
          </div>
        </div>
        <div v-if="PATIENT_SELECTED && (prescriptions.length < 1) && !(PRESCRIPTION_SELECTED || LABORDER_WITHOUT_PRESCRIPTION)" class="col-lg-12 col-md-12 col-sm-12 text-center">
          <i>{{ $t("message.Lab Prescriptions not available for the patient") }}</i>
        </div>
      </transition>

      <transition enter-active-class="slideInUp">
        <div v-if="PATIENT_SELECTED && !(PRESCRIPTION_SELECTED || LABORDER_WITHOUT_PRESCRIPTION)" class="col-12 text-center">
          <n-button type="primary" round @click.native="createLabOrderWithoutPrescription()">
            <h6 class="m-0">{{ $t("message.Create without prescription") }}</h6>
          </n-button>
        </div>
      </transition>

      <!-- Lab details -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && (PRESCRIPTION_SELECTED || LABORDER_WITHOUT_PRESCRIPTION)" id="labs-card">
          <div slot="header">
            <div class="row">
              <div class="col-10">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Lab Details") }}
                </h4>
              </div>
              <div class="col-2 text-right pt-2" v-if="LAB_DETAILS_ENTERED">
                <i class="fa fa-edit fa-2x text-muted" style="font-weight: 100" @click="resetLabDetails()"></i>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center">
              <div class="col-md-12" v-if="LAB_DETAILS_ENTERED">
                <p style="font-weight:bold;">{{selectedLab.name}}</p>
                <p v-if="selectedLab.location && selectedLab.location.addressDetails">
                  {{ selectedLab.location.addressDetails.address }}
                </p>
              </div>

              <check-mark-svg v-if="LAB_DETAILS_ENTERED"></check-mark-svg>
            </div>
          </div>

          <div v-if="!LAB_DETAILS_ENTERED" class="col-md-12 mt-2" @click="clearLabSearchText">
            <fg-input :placeholder="$t('message.Start typing lab name to add')" :addon-right-icon="
                          !labSearchText
                            ? 'now-ui-icons ui-1_zoom-bold'
                            : 'now-ui-icons ui-1_simple-remove'
                        " type="text" v-model="labSearchText" @keyup="searchLab()"></fg-input>
          </div>

          <div v-if="searchedLabs" class="col-md-12" style="margin: 0px">
            <div v-for="lab in searchedLabs" :key="lab._id">
              <card @click.native="selectLab(lab)">
                <div class="col-md-12">
                  {{ lab.name }}
                </div>
                <div class="col-md-12" v-if=" lab.location &&lab.location.addressDetails">
                  {{ lab.location.addressDetails.address }}
                </div>
              </card>
            </div>
          </div>
        </card>
      </transition>

      <!-- Lab tests -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LAB_DETAILS_ENTERED" id="labtests-card">
          <div slot="header">
            <div class="row">
              <div class="col-8">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Lab Tests") }}
                </h4>
              </div>
            </div>
          </div>
          <div v-if="laborder.labTests">
            <div v-for="(labtest, index) in laborder.labTests" :key="labtest._id" class="labtest-card">
              <card>
                <div class="col-10 col-md-10 col-lg-10 pr-0">
                  <p>{{ labtest.name }}</p>
                  <p v-if="labtest.billingDetails">
                    <i :class="getCurrencyClass(labtest.billingDetails.currency)"></i>
                    <span> {{ labtest.billingDetails.amount }}</span>
                  </p>
                </div>
                <div class="col-2 col-md-2 col-lg-2" style="color: red;position: absolute;inset-inline-end: 1em;" @click="deleteLabtest(index)">
                  <i class="el-icon-delete"></i>
                </div>
              </card>
            </div>
          </div>
          <div class="col-md-12 text-center">
            <n-button type="primary" simple round @click.native="addNewLabtest()">
              <i class="fa fa-plus pr-1"></i>
              {{ (laborder.labTests.length > 0) ?  $t("message.Additional lab test") : $t("message.Add Lab Test") }}
            </n-button>
          </div>
          <div class="col-12 text-center" v-if="laborder.labTests && laborder.labTests.length > 0">
            <n-button type="primary" round @click.native="labTestSelectionDone()" v-if="!LABTESTS_SELECTED">
              <h6 class="m-0">{{ $t("message.Next") }}</h6>
            </n-button>
          </div>

          <div class="col-12 text-center" v-if="LABTESTS_SELECTED">
            <check-mark-svg></check-mark-svg>
          </div>
        </card>
      </transition>
      <!-- Sample collection location -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LABTESTS_SELECTED && LAB_DETAILS_ENTERED" id="sample-collection-location">
          <div slot="header">
            <div class="row">
              <div class="col-10">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Sample Collection Location") }}
                </h4>
              </div>
              <div class="col-2 text-right pt-2" v-if="laborder.sampleCollectionLocation">
                <i class="fa fa-edit fa-2x text-muted" style="font-weight: 100" @click="resetLocationSelection()"></i>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12 text-center">
              <div class="col-md-12" v-if="SAMPLE_LOCATION_SELECTED">
                <p>{{laborder.sampleCollectionLocation.address}}</p>
                <p>{{laborder.sampleCollectionLocation.geolocation.landmark}}</p>
              </div>
              <check-mark-svg v-if="SAMPLE_LOCATION_SELECTED"></check-mark-svg>
            </div>
          </div>

          <!-- manual location input -->
          <div v-show="!SAMPLE_LOCATION_SELECTED">
            <div class="row">
              <div class="col-md-12">
                <fg-input>
                  <textarea class="form-control" name="sample-location" :placeholder="$t('message.Enter Address')" v-model="laborder.sampleCollectionLocation.address"></textarea>
                </fg-input>
              </div>
            </div>

            <div class="row" v-show="!GEO_LOCATION_CLEARED">
              <div class="col-md-12">
                <label for="geolocation-landmark" class="ml-3">{{ $t("message.Landmark") }}</label>
                <card>
                  <div class="col-10 col-md-10 col-lg-10" v-if="laborder.sampleCollectionLocation.geolocation">
                    <p>{{laborder.sampleCollectionLocation.geolocation.landmark}}</p>
                  </div>
                  <div class="col-2 col-md-2 col-lg-2" style="position: absolute;inset-inline-end: -0.1em;top: 0.1em;font-size: 2em;" @click="clearGeolocation()">
                    <i class="el-icon-close text-muted"></i>
                  </div>
                </card>
              </div>
            </div>
            <!-- google location search -->
            <div class="row" v-show="GEO_LOCATION_CLEARED">
              <div class="col-md-12">
                <vue-google-autocomplete ref="landmarkLocation" id="location-input" classname="form-control" :placeholder="$t('message.Search landmark')" v-on:placechanged="getAddressData" types="" country="in">
                </vue-google-autocomplete>
              </div>
            </div>

            <div class="row" style="justify-content: center;">
              <n-button type="primary" round style="margin-left: 1em;" @click.native="setSampleLocationAdress()">
                <h6 class="m-0">{{$t('message.Next')}}</h6>
              </n-button>
            </div>
          </div>
        </card>
      </transition>

      <!-- Sample collection time -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LABTESTS_SELECTED &&  LAB_DETAILS_ENTERED && SAMPLE_LOCATION_SELECTED" id="sample-collection-time">
          <div slot="header">
            <div class="row">
              <div class="col-10">
                <h4 slot="header" class="card-title">
                  {{ $t("message.Sample Collection Time") }}
                </h4>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <vue-datetime v-model="sampleCollectionTime" type="datetime" format="dd-MM-yyyy, hh:mm a" :placeholder="$t('message.Select Date and Time')" :minute-step="15" :min-datetime="new Date().toISOString()" :auto="true" :use12-hour="true" :backdrop-click="false" :phrases="{ok:$t('message.OK'), cancel: $t('message.Cancel')}" input-class="form-control"></vue-datetime>
            </div>
          </div>

          <div class="col-12 text-center">
            <n-button type="primary" round @click.native="collectionTimeSelected()" v-if="!COLLECTION_TIME_SELECTED">
              <h6 class="m-0">{{ $t("message.Next") }}</h6>
            </n-button>
          </div>

          <div class="col-12 text-center" v-if="COLLECTION_TIME_SELECTED">
            <check-mark-svg></check-mark-svg>
          </div>
        </card>
      </transition>

      <!-- Payments -->
      <transition enter-active-class="slideInUp">
        <card v-if="PATIENT_SELECTED && LABTESTS_SELECTED &&  SHOW_PAYMENT_GATEWAY" id="payments-card">
          <h4 slot="header" class="card-title">
            {{ $t("message.Payment") }}
          </h4>
          <n-table :columns="['Test','Amount']" :data="paymentBreakupData"></n-table>
          <div class="mb-2  mt-4 text-center" style="font-size: x-large" id="payments-div">
            <div style="
                color: grey;
                border-radius: 10%;
                text-decoration: line-through;
              " v-if="actualAmount && (actualAmount != amount)" class="pl-2">
              <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)"></i>
              <span v-if="actualAmount && (actualAmount != amount)">{{ actualAmount }}</span>
            </div>

            <div>
              <div style="color: grey; border-radius: 10%" class="pl-2 text-primary">
                <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)"></i>
                <span>{{ amount }}</span>
              </div>
              <h3 class="card-category">
                {{ $t("message.Total amount to be paid") }}
              </h3>
            </div>
          </div>

          <div class="row" v-if="SHOW_COUPON_ENTRY && (amount != 0)">
            <div class="col-12 col-md-6 offset-md-3">
              <fg-input class="form-control-lg" name="coupon-code" :placeholder="$t('message.Coupon Code')" v-model="couponCode" onkeyup="this.value = this.value.toUpperCase();" @click.native="IS_COUPON_CODE_ERR = null" :disabled="COUPON_CODE_APPLIED"></fg-input>
              <n-button type="primary" round style="position: absolute; top: -9px; inset-inline-end: 15px; height: 46px" @click.native="applyCoupon()" v-if="this.couponCode && !COUPON_CODE_APPLIED">
                <h6 class="m-0">{{ $t("message.Apply") }}</h6>
              </n-button>
              <n-button type="danger" round style="position: absolute; top: -9px; inset-inline-end: 15px; height: 46px" v-if="COUPON_CODE_APPLIED" @click.native="removeCoupon()">
                <h6 class="m-0">{{ $t("message.Remove") }}</h6>
              </n-button>
            </div>
            <div class="col-12 col-md-6 offset-md-3">
              <span class="text-danger pt-1" v-if="IS_COUPON_CODE_ERR">{{
                couponErrorMessage
              }}</span>

              <span class="text-success pt-1" v-if="COUPON_CODE_APPLIED">
                {{ $t("message.Coupon applied successfully You saved") }}
                <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)"></i>
                {{
                 actualAmount -amount
                }}
              </span>
            </div>
          </div>
          <div id="payment-card-buttons">
            <div class="col-12 text-center" v-if="amount  != 0">
              <div class="col-12 col-lg-12" v-if="settings">
                <div class="card-stats justify-content-center">
                  <n-button v-if="IS_PAYMENT_GATEWAY_AVAILABLE()" type="primary" @click.native="initiatePayment()" round>
                    <span class="pr-2">{{ $t("message.PAY") }}</span>
                    <i :class="getCurrencyClass(laborder.labTests[0].billingDetails.currency)" style="padding-right: 0.2em;"></i>
                    <span>{{ amount }}</span>
                  </n-button>
                  <n-button type="primary" @click.native="initiatePayThroughCredits()" simple style="margin-left:0.5em;" round v-if="settings && settings.paymentSettings && settings.paymentSettings.creditPoints && settings.paymentSettings.creditPoints.enabled && settings.paymentPreferences.labOrders.creditPoints.enabled && creditPointsAvailable()">
                    <span class="pr-2">{{ $t("message.USE CREDIT POINTS") }} - {{ amount }}</span>
                  </n-button>
                </div>
              </div>
            </div>

            <div class="row" v-if="amount == 0">
              <div class="col-12 text-center">
                <n-button type="primary" round @click.native="createLabOrder('Created')">
                  <h6 class="m-0">{{ $t("message.Create Lab Order") }}</h6>
                </n-button>
              </div>
            </div>
          </div>
        </card>
      </transition>

      <transition enter-active-class="slideInUp">
        <div class="col-12 text-center" v-if="PATIENT_SELECTED && LABTESTS_SELECTED &&  LAB_DETAILS_ENTERED && !BILLING_ENABLED">
          <n-button type="primary" round size="lg" @click.native="createLabOrder('Created')" id="btn-start-consulting">
            <h6 class="m-0">
              {{ $t("message.Create Lab Order")}}
            </h6>
          </n-button>
        </div>
      </transition>

      <!-- Lab Tests selction modal-->
      <modal :show.sync="SHOW_LABTEST_SELECTION_MODAL" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white" @close="onLabTestSelectionModalClosed()">
        <h6 slot="header" class="title title-up">{{$t("message.Select Lab Test")}}</h6>
        <div class="row" v-if="!selectedLabTest">
          <div class="col-12 pl-5 pr-5">
            <cool-select class="custom-input" :placeholder="$t('message.Search Lab Tests')" :items="labTests" disable-filtering-by-search @select="selectLabTests" @search="searchLabtest" item-value="name" item-text="name" ref="lab-autocomplete" :search-text.sync="labtestSearchText">
              <template slot="item" slot-scope="{ item }">
                <div class="row">
                  <div class="pr-1 col-11 autocomplete-result">
                    <span class="item-name">{{ item.name }}</span>
                  </div>
                  <div class="pl-0 col-1 autocomplete-result" style="color: #616060;display: flex;justify-content: center;align-items: center;">
                    <i class="now-ui-icons arrows-1_minimal-right"></i>
                  </div>
                </div>
              </template>
            </cool-select>
          </div>
        </div>
        <div class="row pl-3 pr-3" v-if="selectedLabTest">
          <div class="col-12">
            <card>
              <div class="row">
                <div class="col-10 pr-0">
                  <div>
                    {{selectedLabTest.name}}
                  </div>
                  <div v-if="selectedLabTest.description">
                    {{selectedLabTest.description}}
                  </div>
                  <div v-if="selectedLabTest.billingDetails && selectedLabTest.billingDetails.amount">
                    <i :class="getCurrencyClass(selectedLabTest.billingDetails.currency)"></i>
                    {{selectedLabTest.billingDetails.amount}}
                  </div>
                </div>
                <div class="col-2">
                  <n-button type="danger" size="sm" class="mt-0" social icon round @click.native="deleteSelectedLabtest()">
                    <i slot="label" class="now-ui-icons ui-1_simple-remove"></i>
                  </n-button>
                </div>
              </div>
            </card>
          </div>
        </div>
        <template slot="footer">
          <div v-if="selectedLabTest" class="text-center" style="width: 100%;">
            <n-button type="primary" round @click.native="selectLabtest(selectedLabTest)">
              <i class="fa fa-check pr-1"></i>{{ $t("message.Add") }}
            </n-button>
          </div>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
// import ConsentService from "../../../services/consent";
import KhaltiCheckout from "khalti-checkout-web";
import { DatePicker, TimeSelect } from "element-ui";
import ProfileImage from "../components/ProfileImage.vue";
import { AllInOneSDK } from "@ionic-native/all-in-one-sdk/ngx";

export default {
  name: "create-laborder",
  components: {
    ProfileImage,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
  },
  data() {
    return {
      modelValidations: {
        firstName: {
          required: true,
        },
        lastName: {
          required: true,
        },
        email: {
          email: true,
        },
        gender: {
          required: true,
        },
        age: {
          required: true,
        },
      },
      laborder: {
        patient: {
          mobileNumber: "",
        },
        labTests: [],
        status: [],
        sampleCollectionLocation: {},
      },
      sampleCollectionTime: "",
      mobileNumber: null,
      patients: [],
      patientSearchText: null,
      patientAgeYears: null,
      patientAgeMonths: null,
      PATIENT_SELECTED: false,
      isValidMobile: false,
      LAB_DETAILS_ENTERED: false,
      doctors: [],
      selectedLab: null,
      searchedLabs: [],
      SHOW_PAYMENT_GATEWAY: false,
      COUPON_CODE_APPLIED: false,
      couponCode: null,
      IS_COUPON_CODE_ERR: false,
      couponErrorMessage: "",
      labsPagination: {
        totalPages: 0,
        pageNumber: 1,
      },
      labtestSearchText: "",
      labSearchText: "",
      labTests: [],
      LABTESTS_SELECTED: false,
      COLLECTION_TIME_SELECTED: false,
      SHOW_COUPON_ENTRY: true,
      PRESCRIPTION_SELECTED: false,
      LABORDER_WITHOUT_PRESCRIPTION: false,
      prescriptions: [],
      prescriptionsPagination: {
        totalPages: 0,
        pageNumber: 1,
      },
      paymentBreakupData: [],
      SAMPLE_LOCATION_SELECTED: false,
      GEO_LOCATION_CLEARED: false,
      SHOW_LABTEST_SELECTION_MODAL: false,
      selectedLabTest: null,
      stepper: {
        completed: 0,
        total: 6,
      },
      selectedPrescription: null,
    };
  },

  computed: {
    userDetails() {
      return this.$store.state.userDetails;
    },
    settings() {
      return this.$store.state.settings;
    },
    endpoint() {
      return this.$store.state.endpoint;
    },
    BILLING_ENABLED() {
      return this.settings.billingEnabled;
    },
    tenant() {
      return this.settings.tenant;
    },
  },

  async mounted() {
    try {
      if (typeof this.user.endpoint == "string") {
        await this.$store.dispatch("getEndpoint", this.user.endpoint);
      }
      if (
        this.endpoint &&
        this.endpoint.location &&
        this.endpoint.location.addressDetails &&
        this.endpoint.location.addressDetails.geolocation
      ) {
        this.laborder.sampleCollectionLocation.geolocation = {
          landmark: this.endpoint.location.addressDetails.address,
          coordinates:
            this.endpoint.location.addressDetails.geolocation.coordinates,
        };

        this.SAMPLE_LOCATION_SELECTED = true;
      } else {
        this.GEO_LOCATION_CLEARED = true;
      }
    } catch (e) {
      console.log(e);
    }
  },

  methods: {
    addNewLabtest() {
      this.SHOW_LABTEST_SELECTION_MODAL = true;
    },
    onLabTestSelectionModalClosed() {
      this.SHOW_LABTEST_SELECTION_MODAL = false;
      this.selectedLabTest = null;
      this.labtestSearchText = null;
    },
    selectLabTests(labTest) {
      this.selectedLabTest = labTest;
    },
    deleteSelectedLabtest() {
      this.selectedLabTest = null;
    },
    setSampleLocationAdress() {
      if (
        this.laborder.sampleCollectionLocation.geolocation &&
        this.laborder.sampleCollectionLocation.geolocation.landmark &&
        this.laborder.sampleCollectionLocation.geolocation.coordinates.length >
          0
      ) {
        this.SAMPLE_LOCATION_SELECTED = true;
        this.stepper.completed += 1;
        if (this.COLLECTION_TIME_SELECTED) {
          this.stepper.completed += 1;
          this.SHOW_PAYMENT_GATEWAY = true;
          setTimeout(() => {
            this.scrollTo("wrapper");
          }, 500);
        }
      } else {
        swal.fire(this.$t("message.Please select Land mark"));
      }
    },
    async getLabPrescriptions() {
      try {
        let response = await this.$store.dispatch("getLabPrescriptions", {
          pageNumber: this.prescriptionsPagination.pageNumber,
          patientId: this.laborder.patient.patientId,
          hasLabTests: true,
        });
        if (response.data.length > 0) {
          this.prescriptions = response.data;
          this.prescriptionsPagination.totalPages = response.totalPages;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getFormattedDatetime(date) {
      let timestamp = Date.parse(date);
      return moment(Number(timestamp)).format("DD-MM-YYYY, h:mm:ss a");
    },
    createLabOrderWithoutPrescription() {
      this.LABORDER_WITHOUT_PRESCRIPTION = true;
      this.prescriptions = [];
    },
    async selectPrescription(prescription) {
      this.selectedPrescription = prescription;
      this.laborder.appointmentId = prescription.appointmentId;
      this.laborder.labTests = [];
      if (prescription.prescriptions.labPrescription) {
        let labPrescriptions = prescription.prescriptions.labPrescription;

        for (let labPrescription of labPrescriptions) {
          let labtestObj = {
            _id: labPrescription._id,
            name: labPrescription.test,
          };
          //Updating endpoints of labprescription from latest labtest from db
          let labtest = await this.$store.dispatch("getLabTestById", {
            id: labPrescription._id,
          });

          if (labtest && labtest.endpoints && labtest.endpoints.length > 0) {
            labtestObj["endpoints"] = labtest.endpoints;
          } else {
            labtestObj["endpoints"] = labPrescription.endpoints;
          }

          this.laborder.labTests.push(labtestObj);
          this.PRESCRIPTION_SELECTED = true;
        }
      }
      this.prescriptions = [];
      this.getTotalAmount();
      setTimeout(() => {
        this.scrollTo("wrapper");
      }, 500);
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async searchPatients(searchString) {
      try {
        if (searchString.length > 2) {
          this.patients = await this.$store.dispatch("searchPatients", {
            query: searchString,
            pageSize: 20,
          });
        } else {
          this.patients = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    selectPatient(patient) {
      this.patients = [];

      //Clear mobile number field
      this.laborder.patient.mobileNumber = "";
      this.laborder.patient.patientId = patient.patientId;
      this.laborder.patient.firstName = patient.firstName;
      this.laborder.patient.lastName = patient.lastName;

      var m = moment(patient.dob);
      var years = moment().diff(m, "years", false);
      this.patientAgeYears = years;
      m = moment(m).add(years, "years");
      this.patientAgeMonths = moment().diff(m, "months", false);

      this.laborder.patient.gender = patient.gender;
      this.laborder.patient.history = patient.history;
      this.laborder.patient.email = patient.email;
      this.laborder.patient.mobileNumber =
        patient.mobileNumber && patient.mobileNumber.replace(/ /g, "");

      if (this.laborder.patient.mobileNumber) {
        this.mobileNumber = this.laborder.patient.mobileNumber;
      }
      this.laborder.patient.additionalInfo = patient.additionalDetails
        ? patient.additionalDetails
        : {};
      this.laborder.patient.provider = patient.provider;
      if (this.error) this.error = "";
      this.PATIENT_SELECTED = true;
      this.getLabPrescriptions();
      this.stepper.completed += 1;
    },
    mobileNumberUpdate(payload) {
      this.isValidMobile = payload.isValid;
      this.laborder.patient.mobileNumber = payload.formattedNumber;
    },
    calculateDob() {
      let currentYear = new Date().getUTCFullYear();
      let yearOFBirth = currentYear - (this.patientAgeYears || 0);

      let currentMonth = new Date().getMonth() + 1;
      let monthOfBirth = currentMonth - (this.patientAgeMonths || 0);

      if (monthOfBirth == 0 || Math.sign(monthOfBirth) == -1) {
        --yearOFBirth;
        monthOfBirth = 12 + monthOfBirth;
      }
      this.laborder.patient.dob = monthOfBirth + "/01/" + yearOFBirth;
    },
    async resetPatientSelection() {
      this.laborder.patient.firstName = null;
      this.laborder.patient.lastName = null;
      this.laborder.patient.gender = null;
      this.laborder.patient.dob = null;
      this.laborder.patient.history = null;
      this.laborder.patientAgeYears = null;
      this.laborder.patientAgeMonths = null;
      this.laborder.sampleCollectionLocation.address = "";
      this.laborder.sampleCollectionLocation.geolocation = {
        landmark: "",
        coordinates: [],
      };
      if (this.$refs.landmarkLocation) {
        this.$refs.landmarkLocation.clear();
      }
      this.prescriptions = [];
      this.PATIENT_SELECTED = false;
      this.patientAgeYears = null;
      this.patientAgeMonths = null;

      this.PRESCRIPTION_SELECTED = false;

      this.laborder.labTests = [];
      this.LABORDER_WITHOUT_PRESCRIPTION = false;
      this.LABTESTS_SELECTED = false;

      this.LAB_DETAILS_ENTERED = false;
      this.selectedLab = null;

      this.SAMPLE_LOCATION_SELECTED = false;
      try {
        if (typeof this.user.endpoint == "string") {
          await this.$store.dispatch("getEndpoint", this.user.endpoint);
        }

        if (
          this.endpoint &&
          this.endpoint.location &&
          this.endpoint.location.addressDetails &&
          this.endpoint.location.addressDetails.geolocation
        ) {
          this.laborder.sampleCollectionLocation.geolocation = {
            landmark: this.endpoint.location.addressDetails.address,
            coordinates:
              this.endpoint.location.addressDetails.geolocation.coordinates,
          };

          this.SAMPLE_LOCATION_SELECTED = true;
        } else {
          this.GEO_LOCATION_CLEARED = true;
        }
      } catch (e) {
        console.log(e);
      }

      this.COLLECTION_TIME_SELECTED = false;
      this.sampleCollectionTime = "";

      this.SHOW_PAYMENT_GATEWAY = false;

      this.stepper.completed = 0;
    },
    resetLocationSelection() {
      this.SHOW_PAYMENT_GATEWAY = false;
      this.SAMPLE_LOCATION_SELECTED = false;
      this.laborder.sampleCollectionLocation.address = "";
      this.clearGeolocation();
      this.stepper.completed = 3;
      this.$forceUpdate();
    },
    clearGeolocation() {
      this.laborder.sampleCollectionLocation.geolocation = {
        landmark: "",
        coordinates: [],
      };
      if (this.$refs.landmarkLocation) {
        this.$refs.landmarkLocation.clear();
      }
      this.GEO_LOCATION_CLEARED = true;
    },
    getAddressData(addressData, placeResultData, id) {
      let coordinates = [addressData.longitude, addressData.latitude];
      this.laborder.sampleCollectionLocation.geolocation = {
        landmark: placeResultData.formatted_address,
        coordinates: coordinates,
      };
      this.GEO_LOCATION_CLEARED = false;
    },
    async searchLabtest() {
      if (this.labtestSearchText.length > 0) {
        try {
          this.labTests = await this.$store.dispatch("searchLabtests", {
            searchText: this.labtestSearchText,
            lab: this.selectedLab.name,
          });
        } catch (e) {
          this.labTests = [];
          console.log(e);
        }
      } else {
        this.labTests = [];
      }
    },
    labTestSelectionDone() {
      this.LABTESTS_SELECTED = true;
      this.stepper.completed += 1;
      if (
        this.laborder.sampleCollectionLocation.geolocation &&
        this.laborder.sampleCollectionLocation.geolocation.landmark &&
        this.laborder.sampleCollectionLocation.geolocation.coordinates.length >
          0
      ) {
        this.SAMPLE_LOCATION_SELECTED = true;
        this.stepper.completed += 1;
      }
      this.getPaymentBreakupData();
      setTimeout(() => {
        this.scrollTo("wrapper");
      }, 500);
    },
    getPaymentBreakupData() {
      if (this.laborder.labTests) {
        this.paymentBreakupData = [];
        this.laborder.labTests.forEach((labtest) => {
          if (labtest.billingDetails) {
            this.paymentBreakupData.push({
              test: labtest.name,
              amount: labtest.billingDetails.amount,
            });
          }
        });
      }
    },
    collectionTimeSelected() {
      if (this.sampleCollectionTime) {
        this.COLLECTION_TIME_SELECTED = true;
        this.stepper.completed += 1;
        if (this.BILLING_ENABLED) {
          this.SHOW_PAYMENT_GATEWAY = true;
          this.getPaymentBreakupData();
        }
        setTimeout(() => {
          this.scrollTo("wrapper");
        }, 500);
      } else {
        swal.fire(this.$t("message.Please select sample collection time"));
      }
    },
    clearLabSearchText(event) {
      if (event.target.classList.value.indexOf("ui-1_simple-remove") > -1) {
        this.labSearchText = "";
      }
    },

    selectLabtest(labtest) {
      this.laborder.labTests.push(labtest);
      this.labTests = [];
      this.labtestSearchText = null;
      this.setLabtestBillingDetails();
      this.getPaymentBreakupData();
      this.getTotalAmount();
      this.onLabTestSelectionModalClosed();
      this.$forceUpdate();
    },
    deleteLabtest(index) {
      this.laborder.labTests.splice(index, 1);
      this.getPaymentBreakupData();
      if (this.laborder.labTests && this.laborder.labTests.length > 0) {
        this.getTotalAmount();
      } else {
        this.LABTESTS_SELECTED = false;
      }
    },
    getTotalAmount() {
      let total = 0;
      this.laborder.labTests.forEach((labtest) => {
        if (labtest.billingDetails) {
          total = total + Number(labtest.billingDetails.amount);
        }
      });
      this.amount = total;
    },
    validatePatientDetails() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.PATIENT_SELECTED = true;
        }
      });
    },
    async searchLab() {
      try {
        this.searchedLabs = [];
        if (this.labSearchText.length > 0) {
          let response = await this.$store.dispatch("getLabEndpoints", {
            pageNumber: this.labsPagination.pageNumber,
            searchStr: this.labSearchText,
          });
          this.searchedLabs = response.data;
          this.labsPagination.totalPages = response.totalPages;
        }
      } catch (e) {
        console.log(e);
      }
    },
    coolSelectOnKeyUp(event) {
      if (event.key == "Enter") {
        this.$refs.labSearch.$el.querySelector("input").blur();
      }
    },
    resetLabDetails() {
      this.laborder.lab = "";
      this.selectedLab = "";

      this.labSearchText = "";
      this.searchedLabs = [];
      this.LAB_DETAILS_ENTERED = false;
      this.SHOW_PAYMENT_GATEWAY = false;
      this.labsPagination.totalPages = 0;
      this.stepper.completed = 1;

      //Clearing billing details of labtests
      if (this.laborder.labTests && this.laborder.labTests.length > 0) {
        this.laborder.labTests.forEach((labtest) => {
          labtest.billingDetails = null;
        });
      }
    },
    async selectLab(lab) {
      this.laborder.lab = lab.name;
      this.selectedLab = lab;

      //Resetting labtests details
      if (!this.LABORDER_WITHOUT_PRESCRIPTION) {
        await this.selectPrescription(this.selectedPrescription);
      }
      this.setLabtestBillingDetails();
      this.getPaymentBreakupData();

      this.labSearchText = "";
      this.searchedLabs = [];

      if (this.LABORDER_WITHOUT_PRESCRIPTION) {
        this.LAB_DETAILS_ENTERED = true;
        this.stepper.completed += 1;
      }

      if (
        this.laborder.sampleCollectionLocation.geolocation &&
        this.laborder.sampleCollectionLocation.geolocation.landmark &&
        this.laborder.sampleCollectionLocation.geolocation.coordinates.length >
          0 &&
        this.LABTESTS_SELECTED
      ) {
        this.SAMPLE_LOCATION_SELECTED = true;
        this.stepper.completed += 1;
      }
      if (this.LABTESTS_SELECTED) {
        this.stepper.completed += 1;
      }
      if (this.COLLECTION_TIME_SELECTED && this.SAMPLE_LOCATION_SELECTED) {
        this.stepper.completed += 1;
        this.SHOW_PAYMENT_GATEWAY = true;
        setTimeout(() => {
          this.scrollTo("wrapper");
        }, 500);
      }
    },
    setLabtestBillingDetails() {
      //Setting labtests billing details
      if (this.selectedLab) {
        if (this.laborder.labTests && this.laborder.labTests.length > 0) {
          let avialableLabtests = [];
          let notAvialableLabtests = [];
          //Checking avialable and not avialable labtests for selected lab based on billing details
          this.laborder.labTests.forEach((labtest) => {
            if (labtest && labtest.endpoints.length > 0) {
              let endpointName = this.tenant + this.selectedLab.name;
              let endpoint = labtest.endpoints.find(
                (ep) => ep.endpoint == endpointName
              );

              if (
                endpoint &&
                endpoint.billingDetails &&
                Number(endpoint.billingDetails.amount) > 0
              ) {
                labtest.billingDetails = endpoint.billingDetails;
                avialableLabtests.push(labtest);
              } else {
                notAvialableLabtests.push(labtest.name);
              }
            } else {
              notAvialableLabtests.push(labtest.name);
            }
          });

          if (notAvialableLabtests && notAvialableLabtests.length > 0) {
            let text =
              "<ul style='list-style-type: square;text-align:left;margin-top: 1rem;'>";
            notAvialableLabtests.forEach((test) => {
              text =
                text +
                "<li><span style='font-size: 0.7em;font-weight: 400'>" +
                test +
                "</span></li>";
            });
            text = text + "</ul";

            swal
              .fire({
                title: this.$t("message.Following tests are not avialable"),
                html: text,
                confirmButtonText: this.$t("message.Continue"),
                showCancelButton: true,
                cancelButtonText: this.$t("message.Change Lab"),
              })
              .then((result) => {
                if (result && result.value) {
                  this.laborder.labTests = avialableLabtests;
                  this.getTotalAmount();
                  if (!this.LAB_DETAILS_ENTERED) {
                    this.LAB_DETAILS_ENTERED = true;
                    this.stepper.completed += 1;
                  }
                  this.$forceUpdate();
                } else {
                  this.resetLabDetails();
                }
              });
          } else {
            this.laborder.labTests = avialableLabtests;
            this.getTotalAmount();
            if (!this.LAB_DETAILS_ENTERED) {
              this.LAB_DETAILS_ENTERED = true;
              this.stepper.completed += 1;
            }
            this.$forceUpdate();
          }
        }
      }
    },
    async applyCoupon() {
      try {
        if (this.couponCode) {
          let discount = await this.$store.dispatch("applyCouponForLabOrder", {
            // mobileNumber: this.appointment.patient.mobileNumber,
            couponCode: this.couponCode,
            amount: this.amount,
            patientId: this.laborder.patient.patientId,
            userId: this.user._id,
          });
          this.actualAmount = this.amount;
          this.amount = discount.amount;
          this.appliedCouponCode = discount.code;

          this.COUPON_CODE_APPLIED = true;
          this.IS_COUPON_CODE_ERR = false;
        }
      } catch (e) {
        console.log(e);
        // CP001 for negative value of discount
        if (e.response.data.errorCode == "CP001") {
          this.couponErrorMessage = this.$t(
            "message.Billing Amount too low for the coupon to be applied"
          );
        } else {
          this.couponErrorMessage = this.$t(
            "message.Oops! Coupon could not be applied"
          );
        }
        this.IS_COUPON_CODE_ERR = true;
      }
    },
    async removeCoupon() {
      try {
        this.amount = this.actualAmount;
        this.actualAmount = null;

        this.couponCode = null;
        this.COUPON_CODE_APPLIED = false;
      } catch (e) {
        console.log(e);
      }
    },

    async createLabOrder(status) {
      try {
        let that = this;
        this.laborder.status.push({
          status: status,
          updatedBy: this.user.username,
          timestamp: new Date().getTime(),
        });
        this.laborder.latestStatus = status;
        this.laborder.createdBy = "nurse";
        this.laborder.endpoint = this.endpoint.name;
        this.laborder.createdUser = this.user._id;

        //Saving epoch string for Sample Collection time
        if (this.sampleCollectionTime) {
          this.laborder.sampleCollectionTime = new Date(
            this.sampleCollectionTime
          ).getTime();
        }

        if (
          status == "Created" &&
          this.COUPON_CODE_APPLIED &&
          this.amount == 0
        ) {
          let currency = this.laborder.labTests[0].billingDetails.currency;
          this.laborder.billingDetails = {
            paid: true,
            amount: this.amount,
            currency: currency,
            actualAmount: this.actualAmount,
            couponCode: this.appliedCouponCode,
          };
        }

        //Setting billing details if billing is enabled
        if (status == "Blocked") {
          let currency = this.laborder.labTests[0].billingDetails.currency;
          this.laborder.billingDetails = {
            amount: this.amount,
            currency: currency,
          };
          if (this.COUPON_CODE_APPLIED) {
            this.laborder.billingDetails.actualAmount = this.actualAmount;
            this.laborder.billingDetails.couponCode = this.appliedCouponCode;
          }
        }
        let response = await this.$store.dispatch(
          "createLabOrder",
          this.laborder
        );
        this.laborder = response;
        if (status == "Created") {
          this.stepper.completed += 1;
          swal
            .fire({
              title: this.$t("message.Lab Order created successfully!"),
              type: "success",
            })
            .then(() => {
              that.$router.push({ path: "/nursehome" });
            });
        }
      } catch (e) {
        console.log(e);
      }
    },

    creditPointsAvailable() {
      let nurseCommission = 0;
      let type = "labOrder";
      if (
        this.endpoint &&
        this.endpoint.commissionDetails &&
        this.endpoint.commissionDetails.enabled &&
        this.endpoint.commissionDetails[type].enabled &&
        this.endpoint.commissionDetails[type].pricingType &&
        this.endpoint.commissionDetails[type].value
      ) {
        switch (this.endpoint.commissionDetails[type].pricingType) {
          case "fixedPrice":
            nurseCommission = this.endpoint.commissionDetails[type].value;
            break;
          case "fixedMargin":
            nurseCommission = parseInt(
              this.endpoint.commissionDetails[type].value
            );
            break;
          case "percentageMargin":
            nurseCommission =
              parseInt(this.amount) *
              (parseInt(this.endpoint.commissionDetails[type].value) / 100);
            break;
          default:
            nurseCommission = 0;
        }
      } else {
        nurseCommission = 0;
      }

      let customLimit = 0;
      if (
        this.settings &&
        this.settings.customCreditsLimit &&
        this.settings.customCreditsLimit.labOrder.enabled
      ) {
        customLimit = this.settings.customCreditsLimit.minLimit;
      }
      let requiredCredits = this.amount - nurseCommission + customLimit;

      return this.userDetails.credits >= requiredCredits;
    },

    IS_PAYMENT_GATEWAY_AVAILABLE() {
      return (
        (this.settings.paymentSettings.razorpay.enabled &&
          this.settings.paymentPreferences.labOrders.razorpay.enabled &&
          RazorpayCheckout) ||
        (this.settings.paymentSettings.paytm.enabled &&
          this.settings.paymentPreferences.labOrders.paytm.enabled) ||
        (this.settings.paymentSettings.khalti.enabled &&
          this.settings.paymentPreferences.labOrders.khalti.enabled)
      );
    },

    async initiatePayment() {
      //create lab order with blocked status
      await this.createLabOrder("Blocked");

      if (
        this.settings.paymentSettings.razorpay.enabled &&
        this.settings.paymentPreferences.labOrders.razorpay.enabled &&
        RazorpayCheckout
      ) {
        this.initiateRazorPayPayment();
      } else if (
        this.settings.paymentSettings.paytm.enabled &&
        this.settings.paymentPreferences.labOrders.paytm.enabled
      ) {
        this.initiatePaytmPayment();
      } else if (
        this.settings.paymentSettings.khalti.enabled &&
        this.settings.paymentPreferences.labOrders.khalti.enabled
      ) {
        this.initiateKhaltiPayment();
      } else {
        swal.fire(this.$t("message.Error with payment method"));
      }
    },
    async initiatePayThroughCredits() {
      //create lab order with blocked status
      if (!this.laborder || !this.laborder._id) {
        await this.createLabOrder("Blocked");
      }
      this.payThroughCredits();
    },

    async payThroughCredits() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      try {
        let transaction = await this.$store.dispatch(
          "laborderPaymentUsingCredits",
          {
            laborderId: this.laborder._id,
          }
        );

        if (
          transaction &&
          transaction.latestStatus &&
          transaction.latestStatus == "Success"
        ) {
          //Confirm lab order after payment success
          that.laborder = await that.$store.dispatch("updateLabOrderStatus", {
            laborderId: that.laborder._id,
            status: "Created",
          });

          swal
            .fire({
              type: "success",
              title: that.$t("message.Payment successful!"),
              text: that.$t("message.Lab Order created successfully!"),
            })
            .then(() => {
              that.$router.push({
                path: "/viewlaborderdetails/" + that.laborder._id,
              });
            });
        } else {
          throw new Error("Payment failed");
        }
      } catch (error) {
        console.log(error);
        swal.fire({
          type: "error",
          title: that.$t("message.Payment failed!"),
          timer: 5000,
        });
      }
    },

    async initiateRazorPayPayment() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;
      let transaction = await this.$store.dispatch("initiateLabOrderPayment", {
        gateway: "razorpay",
        laborderId: this.laborder._id,
        patient: this.patient,
      });

      var options = {
        order_id: transaction.paymentDetails.orderId,
        description: this.settings.paymentSettings.razorpay.paymentDescription,
        key: this.settings.paymentSettings.razorpay.key_id,
        currency: transaction.paymentDetails.currency,
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
        name: this.settings.paymentSettings.razorpay.name,
        image: "https://i.imgur.com/n5tjHFD.png",
        prefill: {
          name:
            this.laborder.patient.firstName +
            " " +
            this.laborder.patient.lastName,
          email:
            this.laborder.patient.email ||
            this.settings.directBookings.defaultEmail ||
            "",
          contact: this.laborder.patient.mobileNumber,
        },
        theme: {
          color:
            document.documentElement.style.getPropertyValue(
              "--color-primary"
            ) || "#f96332",
        },
      };

      if (this.settings.paymentSettings.razorpay.logoUrl) {
        options.image = this.settings.paymentSettings.razorpay.logoUrl;
      }

      window.razorpaySuccessCallback = async function (response) {
        response.laborderId = that.laborder._id;
        response.razorpay_order_id = transaction.paymentDetails.orderId;
        try {
          let verificationResponse = await that.$store.dispatch(
            "verifyLabOrderPayment",
            {
              gateway: "razorpay",
              transaction: response,
            }
          );

          if (
            verificationResponse &&
            verificationResponse.latestStatus == "Success"
          ) {
            //Confirm lab order after payment success
            that.laborder = await that.$store.dispatch("updateLabOrderStatus", {
              laborderId: that.laborder._id,
              status: "Created",
            });

            swal
              .fire({
                type: "success",
                title: that.$t("message.Payment successful!"),
                text: that.$t("message.Lab Order created successfully!"),
              })
              .then(() => {
                that.$router.push({
                  path: "/viewlaborderdetails/" + that.laborder._id,
                });
              });
          } else {
            throw new Error("Payment failed");
          }
        } catch (e) {
          console.log(e);
          swal.fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            text: that.$t(
              "message.Any consultation fees paid will be refunded within 7 working days"
            ),
            timer: 5000,
          });
        }
      };

      window.razorpayCancelCallback = function (error) {
        console.log(error);
        swal
          .fire({
            type: "error",
            title: that.$t("message.Payment failed!"),
            text: that.$t(
              "message.Any consultation fees paid will be refunded within 7 working days"
            ),
            timer: 5000,
          })
          .then(() => {
            that.$router.push("/nursehome");
          });
      };

      RazorpayCheckout.on("payment.success", window.razorpaySuccessCallback);
      RazorpayCheckout.on("payment.cancel", window.razorpaySuccessCallback);
      RazorpayCheckout.open(options);
    },
    async initiatePaytmPayment() {
      let that = this;
      try {
        let loader = this.$loading.show();
        let allInOneSDK = new AllInOneSDK();

        //Call Initiate Transaction API from your backend to generate Transaction Token.
        let transaction = await this.$store.dispatch(
          "initiateLabOrderPayment",
          {
            gateway: "paytm",
            laborderId: this.laborder._id,
            patient: this.patient,
          }
        );

        let isStaging =
          that.settings.paymentSettings.paytm.callbackUrl.includes("stage");

        // constructor(private allInOneSDK : AllInOneSDK) {}
        let paymentIntent = {
          mid: that.settings.paymentSettings.paytm.mid,
          orderId: transaction.paymentDetails.orderId,
          txnToken: transaction.paymentDetails.txnToken, //"<Transaction Token generated by Initiate Transaction API from your backend>",
          amount: transaction.paymentDetails.amount,
          isStaging: isStaging,
          callbackUrl:
            that.settings.paymentSettings.paytm.callbackUrl +
            "?ORDER_ID=" +
            transaction.paymentDetails.orderId,
          restrictAppInvoke: isStaging,
          enableAssist: true,
        };

        allInOneSDK
          .startTransaction(paymentIntent)
          .then(async (resp) => {
            // The response received after the transaction is completed will be an object containing "message" and "response". You can parse both and use them as required in your application
            // alert(JSON.parse(resp.response));
            let response = JSON.parse(resp.response);

            if (response.STATUS == "TXN_SUCCESS") {
              try {
                response.laborderId = that.laborder._id;
                response.transactionId = transaction._id;
                let verificationResponse = await that.$store.dispatch(
                  "verifyLabOrderPayment",
                  {
                    gateway: "paytm",
                    transaction: response,
                  }
                );
                if (
                  verificationResponse &&
                  verificationResponse.latestStatus == "Success"
                ) {
                  //Confirm lab order after payment success
                  that.laborder = await that.$store.dispatch(
                    "updateLabOrderStatus",
                    {
                      laborderId: that.laborder._id,
                      status: "Created",
                    }
                  );

                  swal
                    .fire({
                      type: "success",
                      title: that.$t("message.Payment successful!"),
                      text: that.$t("message.Lab Order created successfully!"),
                    })
                    .then(() => {
                      that.$router.push({
                        path: "/viewlaborderdetails/" + that.laborder._id,
                      });
                    });
                } else {
                  throw new Error("Payment failed");
                }
              } catch (error) {
                console.error(error);
                throw new Error("Payment failed");
              }
            } else {
              // createappointment28
              throw new Error("Payment failed");
            }
          })
          .catch((error) => {
            // alert(error);
            console.error(error);
            swal.fire({
              type: "error",
              title: that.$t("message.Payment failed!"),
              text: that.$t(
                "message.Any consultation fees paid will be refunded within 7 working days"
              ),
              timer: 5000,
            });
          });
        loader.hide();
      } catch (error) {
        console.log(error);
        loader.hide();
      }
    },
    async initiateKhaltiPayment() {
      let that = this;
      this.PAYMENT_INPROGRESS = true;

      let transaction = await this.$store.dispatch("initiateLabOrderPayment", {
        gateway: "khalti",
        laborderId: this.laborder._id,
        patient: this.laborder.patient,
      });

      let config = {
        publicKey: that.settings.paymentSettings.khalti.publicKey,
        productIdentity: that.laborder._id,
        productName: "LabOrder",
        productUrl: window.location.href,
        eventHandler: {
          async onSuccess(response) {
            console.log(response);
            response.laborderId = that.laborder._id;
            response.transactionId = transaction._id;
            let verificationResponse = await that.$store.dispatch(
              "verifyLabOrderPayment",
              {
                gateway: "khalti",
                transaction: response,
                patient: that.laborder.patient,
              }
            );

            if (
              verificationResponse &&
              verificationResponse.latestStatus == "Success"
            ) {
              //Confirm lab order after payment success
              that.laborder = await that.$store.dispatch(
                "updateLabOrderStatus",
                {
                  laborderId: that.laborder._id,
                  status: "Created",
                }
              );
              swal
                .fire({
                  type: "success",
                  title: that.$t("message.Payment successful!"),
                  text: that.$t("message.Lab Order created successfully!"),
                  timer: 3000,
                })
                .then(() => {
                  that.$router.push("/nursehome");
                });
            } else {
              that.PAYMENT_INPROGRESS = false;
              throw new Error("Payment failed");
            }
          },
          // onError handler is optional
          onError(error) {
            // handle errors
            that.PAYMENT_INPROGRESS = false;
            swal.fire(that.$t("message.Payment error"));
            console.log(error);
          },
          onClose() {
            that.PAYMENT_INPROGRESS = false;
          },
        },
        paymentPreference: [
          "KHALTI",
          "EBANKING",
          "MOBILE_BANKING",
          "CONNECT_IPS",
          "SCT",
        ],
      };

      let khaltiCheckout = new KhaltiCheckout(config);
      khaltiCheckout.show({
        amount: Number(transaction.paymentDetails.amount) * 100 + "",
      });
    },
  },
  watch: {
    patientAgeYears: function () {
      this.calculateDob();
    },
    patientAgeMonths: function () {
      this.calculateDob();
    },
    "prescriptionsPagination.pageNumber": function () {
      this.getLabPrescriptions();
    },
  },
};
</script>

<style scoped>
/deep/ .IZ-select__item {
  border-bottom: 1px solid lightgrey;
}
/deep/.modal-content .modal-header {
  padding-bottom: 1em;
}
.autocomplete-result {
  margin-top: 1em;
  margin-bottom: 1em;
}
/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}
/deep/ .IZ-select__no-data {
  text-align: center;
}
/deep/ .modal-dialog {
  max-width: inherit;
}
/deep/ .labtest-card .card-body {
  display: flex;
}
/deep/ #location-input:focus {
  border: 1px solid #1be611;
}
#wrapper {
  scroll-behavior: smooth;
}
</style>
